import { lazy } from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import type { RouteRecord } from 'vite-react-ssg';
import LangLayout from './layouts/LangLayout';
import { SUPPORTED_SLUGS } from './hooks/useLocalePath';
import './styles/globals.css';

// Lazy-loaded pages
const Home = lazy(() => import('./pages/Home'));
const Manifesto = lazy(() => import('./pages/Manifesto'));
const Services = lazy(() => import('./pages/Services'));
const Industries = lazy(() => import('./pages/Industries'));
const Contact = lazy(() => import('./pages/Contact'));

/** Redirect root / to /en/ (or last used language) */
function RootRedirect() {
    const navigate = useNavigate();
    useEffect(() => {
        let target = 'en';
        try {
            const saved = localStorage.getItem('perceptya-lang');
            if (saved === 'PT') target = 'pt-br';
            else if (saved === 'ES') target = 'es';
        } catch { /* noop */ }
        navigate(`/${target}`, { replace: true });
    }, [navigate]);
    return null;
}

export const routes: RouteRecord[] = [
    {
        path: '/:lang',
        Component: LangLayout,
        getStaticPaths: () => [...SUPPORTED_SLUGS],
        children: [
            {
                index: true,
                Component: Home,
            },
            {
                path: 'manifesto',
                Component: Manifesto,
            },
            {
                path: 'services',
                Component: Services,
            },
            {
                path: 'industries',
                Component: Industries,
            },
            {
                path: 'contact',
                Component: Contact,
            },
        ],
    },
    {
        path: '/',
        Component: RootRedirect,
    },
    {
        path: '*',
        Component: RootRedirect,
    },
];
